var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.658203,
    y: 0.630859,
    width: 40.7233,
    height: 40.5798,
    rx: 20.2899,
    fill: "#200B32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9277 27.1252C15.6195 27.1431 15.3165 27.0407 15.0825 26.8395C14.6209 26.3752 14.6209 25.6253 15.0825 25.161L25.1889 15.0546C25.6689 14.6054 26.4222 14.6304 26.8714 15.1104C27.2776 15.5445 27.3013 16.2118 26.9268 16.6736L16.7609 26.8395C16.5299 27.0378 16.2317 27.14 15.9277 27.1252Z",
    fill: "#A079BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0209 27.1254C25.7086 27.124 25.4093 27.0001 25.1876 26.7802L15.0812 16.6737C14.6536 16.1743 14.7117 15.4229 15.211 14.9952C15.6567 14.6136 16.314 14.6136 16.7596 14.9952L26.9256 25.1017C27.4055 25.551 27.4303 26.3043 26.981 26.7842C26.9631 26.8033 26.9446 26.8218 26.9256 26.8397C26.6766 27.0561 26.349 27.1596 26.0209 27.1254Z",
    fill: "#A079BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoClose);
export default __webpack_public_path__ + "static/media/info_close.85472502b2271304b6454dacfee16bb6.svg";
export { ForwardRef as ReactComponent };